import type { SVGProps } from 'react';
const SvgCalendar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    height={16}
    fill="none"
    width={16}
    {...props}
  >
    <g clipPath="url(#Calendar_svg__a)">
      <path
        d="M1.204 6.64h13.594M4.83 4.376V1.203m6.344 3.172V1.203M2.111 3.016h11.78s.907 0 .907.906v9.969s0 .906-.906.906H2.11s-.907 0-.907-.906V3.92s0-.905.907-.905"
        strokeLinejoin="round"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth={1.5}
      />
    </g>
    <defs>
      <clipPath id="Calendar_svg__a">
        <path d="M0 0h16v16H0z" fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCalendar;
